import React, { useState } from 'react';
import './HelpCenter.css';
import ConfirmationModal from '../../components/UI/ConfirmationModal';
import ContactUsModal from './ContactUsModal';

const HelpCenter = () => {
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [activeFAQIndex, setActiveFAQIndex] = useState(null);

  const faqs = [
    {
      question: 'What can I do to resolve an issue?',
      answer:
        "If you're encountering an issue, here are steps you can take to resolve it:\nEnsure you've updated your browser to the latest version, cleared your cache, or restarted your device.\nIf your issue persists after taking the above steps, feel free to contact our customer support team for further assistance (use the Contact Us button above)."
    },
    {
      question: 'Why is the web page slow to respond?',
      answer:
        "There are several reasons why a web page may respond slowly:\nThe website may experience high volumes of user traffic, causing temporary slowdowns.\nCheck if your internet connection is stable and fast. You may try restarting your router or switching to a different network.\nOutdated browsers or an excessive number of open tabs can impact page performance. Clear your browser cache and ensure you are using an updated browser.\nWe occasionally perform server updates or maintenance, which may momentarily impact responsiveness.\nIf the issue is recurring or unresolved, kindly reach out to customer care for support."
    },
    {
      question: 'Is there a user guide?',
      answer:
        "Yes, we provide a detailed user guide to help you navigate and make the most out of our platform."
    },
    {
      question: 'How can I contact customer care?',
      answer:
        "We're here to help! You can contact our customer care team through an email at [emtechsupport@eberhard.com] with a description of your issue.\n\nWe aim to respond to all inquiries within 24 hours."
    },
    {
      question: 'Why am I facing stuttering while browsing the site?',
      answer:
        "Stuttering or interruptions while browsing may occur due to:\nA slow or unstable internet connection can cause interruptions. Switching to a stable network may resolve the issue.\n Try closing unnecessary apps running in the background.\nEnsure you are using the latest version of a compatible browser. Clearing your browser cache may help.\nIf none of these steps work, please contact customer support. They can help diagnose the problem further."
    }
  ];

  const toggleFAQ = (index) => {
    if (activeFAQIndex === index) {
      setActiveFAQIndex(null);
    } else {
      setActiveFAQIndex(index);
    }
  };

  const openContactUs = () => {
    setIsContactUsOpen(true);
  };

  const closeContactUs = () => {
    setIsContactUsOpen(false);
  };

  const handleContactSubmit = () => {
    setIsContactUsOpen(false);
    setIsConfirmationOpen(true);
  };

  const closeConfirmation = () => {
    setIsConfirmationOpen(false);
  };

  return (
    <div className="helpcenter-container">
      <div className="helpcenter-header">
        <h2>Help Center</h2>
        <button className="contact-us-button" onClick={openContactUs}>
          Contact Us
        </button>
      </div>

      <div className="helpcenter-content">
        <div className="helpcenter-section faq-section">
          <h3 className="section-title">FAQ</h3>
          {faqs.map((faq, index) => (
            <div
              className="faq-item"
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                {faq.question}
                <span
                  className={`faq-toggle-icon ${
                    activeFAQIndex === index ? 'open' : ''
                  }`}
                >
                  &gt;
                </span>
              </div>
              {activeFAQIndex === index && (
                <div
                  className="faq-answer"
                  data-testid="faq-answer"
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="helpcenter-footer">
        <button className="view-terms-button" onClick={() => window.location.href = "https://www.eberhard.com/policies"}>
          View Terms & Conditions
        </button>
        <button className="view-privacy-button" onClick={() => window.location.href = "https://www.eberhard.com/privacy-policies"}>
          View Privacy Policy
        </button>
      </div>

      <ContactUsModal
        isOpen={isContactUsOpen}
        onClose={closeContactUs}
        onSubmit={handleContactSubmit}
      />

      <ConfirmationModal
        isOpen={isConfirmationOpen}
        onCancel={closeConfirmation}
        onConfirm={closeConfirmation}
        message="You are now being redirected to your email client to contact Eberhard support."
        confirmLabel="OK"
        showCancel={false}
      />
    </div>
  );
};

export default HelpCenter;
